export default "__VITE_ASSET__CWNJ33H2__"